import { Icon } from "@ui/Icon";
import { type JSX, Show } from "solid-js";
import { CloseButton } from "../../CloseButton";
import "./PanelHeader.css";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Stack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";

type Props = {
	title: string;
	subTitle?: JSX.Element;
	/** @deprecated Use `symbol` instead */
	icon?: string;
	symbol?: string;
	titleContent?: JSX.Element;
	onToggle: () => void;
	id: string;
};

export const PanelHeader = (props: Props) => {
	return (
		<Stack
			class="panel-header"
			direction="row"
			align="center"
			spacing="large"
			justify="space-around"
		>
			<Show when={props.symbol}>
				<MaterialSymbol
					// relativeSize="1.375rem"
					symbol={props.symbol}
					style={{ "font-size": "1.375rem" }}
					color="fg3"
				/>
			</Show>
			<Show when={props.icon}>
				<Icon
					icon={props.icon}
					width="1.375rem"
					height="1.375rem"
					fill="var(--colour-fg-3)"
				/>
			</Show>

			<Stack justify="start" spacing="none" style={{ flex: 1 }}>
				<Text family="mono" transform="uppercase" weight="bold" size="standard">
					{props.title}

					{props.titleContent}
				</Text>
				<Show when={props.subTitle}>
					<Text color="fg3" size="small">
						{props.subTitle}
					</Text>
				</Show>
			</Stack>
			<CloseButton onClick={props.onToggle} />
		</Stack>
	);
};
